import { render, staticRenderFns } from "./salesCommissionRecord.vue?vue&type=template&id=cce1edf4"
import script from "./salesCommissionRecord.vue?vue&type=script&lang=js"
export * from "./salesCommissionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports